import type { SVGProps } from "react"

export default function ShareFacebook(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26 13C26 5.82029 20.1797 0 13 0C5.82029 0 0 5.82029 0 13C0 19.4886 4.75406 24.8669 10.9688 25.8422V16.7578H7.66797V13H10.9688V10.1359C10.9688 6.87781 12.9096 5.07812 15.879 5.07812C17.3009 5.07812 18.7891 5.33203 18.7891 5.33203V8.53125H17.1498C15.535 8.53125 15.0312 9.53269 15.0312 10.5604V13H18.6367L18.0604 16.7578H15.0312V25.8422C21.2459 24.8669 26 19.4886 26 13Z"
        fill="#1877F2"
      />
      <path
        d="M18.0604 16.7578L18.6367 13H15.0312V10.5604C15.0312 9.53269 15.535 8.53125 17.1498 8.53125H18.7891V5.33203C18.7891 5.33203 17.3009 5.07812 15.879 5.07812C12.9096 5.07812 10.9688 6.87781 10.9688 10.1359V13H7.66797V16.7578H10.9688V25.8422C11.6372 25.9474 12.3125 26.0005 13 26C13.6875 26.0005 14.3628 25.9474 15.0312 25.8422V16.7578H18.0604Z"
        fill="white"
      />
    </svg>
  )
}
